import type { QueryClient } from "@tanstack/react-query";

import { refreshPayrollWorkflowQueries } from "../routes/payrollWorkflow.js";

/** Source imports may affect later navigation, but Refresh only fetches this view. */
export async function refreshScopedSourceQueries(
  client: QueryClient,
  scope: "payroll" | "work_profiles",
  month: string,
) {
  const families = [
    "payroll-profiles",
    "timesheet-versions",
    "pohoda-preview",
    "pohoda-exports",
    "payslips",
    "balances",
    "payroll-workflow",
    "payroll-audit",
  ];
  await Promise.all(
    families.map((family) =>
      client.invalidateQueries({
        queryKey: ["openproject", family],
        refetchType: "none",
      }),
    ),
  );
  const refetch = (queryKey: readonly unknown[], exact: boolean) =>
    client.refetchQueries(
      { queryKey, exact, type: "active" },
      { throwOnError: true },
    );
  if (scope === "work_profiles") {
    await refetch(["openproject", "payroll-profiles", "directory"], true);
    return;
  }
  await refreshPayrollWorkflowQueries({
    month,
    refetch,
    invalidate: (queryKey, exact) =>
      client.invalidateQueries({ queryKey, exact, refetchType: "none" }),
  });
}
